/* eslint-disable consistent-return */
import {
  Avatar,
  Button,
  Grid,
  Paper,
  Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FindInPage, Room, Search } from '@material-ui/icons';
import Business from '@material-ui/icons/Business';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import SendIcon from '@material-ui/icons/Send';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  connectABusinessPartner,
  getBusinessSearch,
  getInfosDashboard,
  getNumberJobById,
  getSchoolsPartners,
} from '@webapps/business';
import {
  FormikTextField,
  Loader,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ConfirmDialog from 'components/ConfirmDialog';
import Row from 'components/Form/Row';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const searchSchema = yup.object().shape({
  keyword: yup.string(),
});

const LightTooltip = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
  },
}))(Tooltip);

const AddPartnerCard = ({
  account,
  address,
  refetch,
  id,
  name,
  sector,
  handleOpenConfirmDialog,
  setEmailSelect,
}) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [page, setPage] = useState(1);

  const [keywordRequest, setKeywordRequest] = useState('');

  const { data: nbr } = useQuery(getNumberJobById, {
    key: ['nbrOffers', id],
    variables: { id },
  });

  const { data: infos } = useQuery(getInfosDashboard, {
    key: ['infos', id],
    variables: { id },
  });

  const {
    status: load,
    data: { content: businesses = [], totalElements } = {},
    isFetching,
  } = useQuery(getBusinessSearch, {
    key: ['searchBusinessForPartner', keywordRequest + page],
    variables: {
      keyword: keywordRequest,
      page: page - 1,
      size: 3,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectABusinessPartner);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const { push } = useRouter();
  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleCloseConfirmDialog();
      refetch();
    }
  }, [isSuccessConnect]);

  const formik = useFormik({
    initialValues: {
      keyword: '',
    },
    validationSchema: searchSchema,
    onSubmit: ({ keyword }) => {
      setKeywordRequest(keyword);
      setPage(1);
    },
  });

  const viewPartner = (id) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id } });
  };

  const { data: { content: mypartnersAccepted = [] } = {} } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersAccepted', page],
      variables: {
        id: idUser,
        type: 'accepted',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: mypartnersReceived = [] } = {} } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersReceived', page],
      variables: {
        id: idUser,
        type: 'received',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: mypartnersRequested = [] } = {} } = useQuery(
    getSchoolsPartners,
    {
      key: ['schoolsPartnersRequested', page],
      variables: {
        id: idUser,
        type: 'requested',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const reqPartner = async (id) => {
    const allPartners = [
      ...mypartnersAccepted,
      ...mypartnersReceived,
      ...mypartnersRequested,
    ];
    if (
      allPartners.filter(({ id: idPartnerExist }) => idPartnerExist === id) <= 0
    ) {
      setErrorExist(false);
      await mutateConnect({
        data: {
          schoolId: idUser,
          businessId: id,
        },
      });
    } else {
      handleCloseConfirmDialog();
      setErrorExist(true);
    }
  };

  return (
    <Grid key={id} item xs={12} sm={12} md={4}>
      <Paper className={classes.cardContainer} elevation={0}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className={cx(global.title, classes.avatarNameDiv)}>
            <Avatar
              className={classes.avatar}
              src={infos?.profile?.profileImageUrl}
            />
            <div className={classes.nameAdressDiv}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: 5,
                }}
              >
                {name} <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />
              </div>
              <div className={cx(global.frac, global.infoText)}>
                <Room className={global.infoIcon}/>{' '}
                {account?.address?.city || 'Adresse'}{' '}
                {account?.address?.cityCode}
              </div>
            </div>
          </div>
          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              rowGap: 10,
              marginTop: 20,
              marginBottom: 20,
            })}
          >
            <div
              className={cx(global.infoText, classes.address)}
            >

              <Partenaire className={global.smallIcon} /> Partenaire interne

            </div>

            <div
              className={cx(global.infoText, classes.address)}
            >
              <Business className={global.smallIcon} />
              {sector ? sector?.label : 'Non spécifié'}
            </div>
            <div
              className={cx(global.infoText, classes.address)}
            >
              <FindInPage className={global.smallIcon} />
              {nbr} Offres disponible

            </div>
            <div
              className={cx(global.infoText, classes.address)}
            >
              <MailIcon className={global.smallIcon} />
              Masquée jusqu'à acceptation du partenaire
            </div>
            <div className={cx(global.infoText, classes.address)}>
              <PhoneIcon className={global.smallIcon} />
              <div>Masquée jusqu'à acceptation du partenaire</div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              rowGap: 10,
            }}
          >

            {account?.subscription?.toLowerCase() === 'premium' ? (
              <>
                <Button
                  disabled={isLoadingConnect}
                  onClick={() => handleOpenConfirmDialog(id)}
                  fullWidth
                  disableElevation
                  variant="contained"
                  color="primary"
                  className={classes.button}
                >
                  Demander un partenariat
                </Button>
              </>
            ) : (
              <LightTooltip
                title="Vous ne pouvez pas ajouter un partenaire ayant un compte gratuit 🔒"
                placement="top"
              >
                <span>
                  <Button
                    disabled
                    fullWidth
                    color="primary"
                    variant="contained"
                    className={[classes.button, css({ borderRadius: 400 })]}
                  >
                    Demander un partenariat
                  </Button>
                </span>
              </LightTooltip>
            )}
            <div>
              <Button
                onClick={() => viewPartner(id)}
                fullWidth
                variant="contained"
                disableElevation
                style={{
                  color: '#5A6DA1',
                  backgroundColor: '#F3F7FF',
                  outline: '1px solid #C0D9FF',
                  borderRadius: 10
                }}
              >
                Voir la vitrine
              </Button>
            </div>
          </div>
        </div>
      </Paper>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  cardContainer: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    height: '100%',
    padding: 20,
  },
  PartenerCardContainer: {
    margin: 0,
    width: '100%',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  nameAdressDiv: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 10,
  },
  avatarNameDiv: {
    columnGap: 20,
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    // columnGap: 5,

    alignItems: 'center',
  },
  avatar: {
    height: 80,
    width: 80,
  },
  button: {
    borderRadius: '400px',
  },
});

export default AddPartnerCard;
